// ===========================================
// PROTECTED ROUTE COMPONENT
// Unauthenticated → Sales /login with returnPath so Hub SSO keeps intent
// ===========================================

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store';
import { sanitizeHubReturnPath } from '../../lib/hubReturnPath';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    const returnPath = sanitizeHubReturnPath(
      `${location.pathname}${location.search || ''}`,
      '/dashboard'
    );
    const qs = new URLSearchParams({
      sso: 'hub',
      returnPath,
    });
    return <Navigate to={`/login?${qs.toString()}`} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
